import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { chain } from 'lodash';
import { SearchPreset } from '@retro-ui/api-contract';

import { useConfig } from '@f/hooks';
import { StartingMaterialReducer } from '@f/services/starting-material/starting-material.types';

import { validateDatasets } from './validateDatasets';

export function useSearchParamsValidation(searchParams: SearchPreset) {
  const datasetsById = useSelector((state: any) => {
    const startingMaterial = state.startingMaterial as StartingMaterialReducer;
    return startingMaterial.dataset.data;
  });

  const datasetsByExtendedId = chain(datasetsById).values().keyBy('extendedId').value();

  const config = useConfig();
  const { datasetSizeLimitPerSearch } = config.startingMaterial;

  const validate = (searchParams: SearchPreset) => {
    const datasetValidation = validateDatasets(
      searchParams,
      datasetsByExtendedId,
      datasetSizeLimitPerSearch
    );

    return {
      ...datasetValidation,
      isValid: datasetValidation.isValid,
    };
  };

  const validation = useMemo(() => validate(searchParams), [searchParams, datasetsByExtendedId]);

  return {
    validation,
    validate,
  };
}
